import { ConsentBanner } from "@sylviq/ui-react-web/blocks/consent/ConsentBanner";
import "@sylviq/ui-react-web/styles.css";
import "./www-theme.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { PlatformStatusGate } from "@/features/status/PlatformStatusGate";
import { initAnalyticsIfConsented } from "@/lib/analytics";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <PlatformStatusGate>
      <App />
    </PlatformStatusGate>
    <ConsentBanner
      policyHref="/legal/cookies"
      onConsentChange={() => void initAnalyticsIfConsented()}
    />
  </StrictMode>,
);

void initAnalyticsIfConsented();
